import styled from 'styled-components';

import { media } from '../../../styles/media';
import { LinkBadge } from '../../Button';

export const Root = styled.div`
  background: ${props => props.theme.color.white};
  box-shadow: 0 0 22px 0 rgba(0, 0, 0, 0.08);
  position: relative;

  ${media.tablet`
    display: flex;
    flex-direction: row;

    min-height: 450px;
  `};
`;

export const Title = styled.h4`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;

  font-family: ${props => props.theme.font.bold};
  font-size: 1.85rem;
  letter-spacing: 1.32px;
  text-transform: uppercase;

  margin-bottom: ${props => props.theme.layout.gutter}px;

  > i {
    font-size: 2.5rem;

    margin-right: ${props => props.theme.layout.gutter / 8}px;
  }

  ${media.tablet`
    font-size: 2.8rem;
    letter-spacing: 2px;

    margin-bottom: ${props => props.theme.layout.gutter * 2.5}px;

    > i {
      font-size: 3.8rem;
    }
  `};

  ${media.desktop`
    > i {
      margin-right: ${props => props.theme.layout.gutter / 2}px;
    }
  `};
`;

export const Header = styled.div`
  text-align: center;
  position: relative;

  color: ${props => props.theme.color.white};

  background-color: ${({ theme }) => theme.color.brand.primary};

  padding: ${props => props.theme.layout.gutter * 1.5}px;

  > a,
  button {
    min-width: auto;
  }

  ${media.tablet`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    width: 50vw;
    text-align: left;

    padding: ${props => props.theme.layout.gutter * 3.25}px 8vw ${props =>
    props.theme.layout.gutter * 1.5}px;
  `};

  ${media.desktop`
    width: 38vw;
  `};
`;

export const Content = styled.div`
  text-align: center;

  overflow: hidden;

  ${LinkBadge} {
    > i {
      font-size: 1rem;
      margin-right: ${props => props.theme.layout.gutter / 2}px;

      &:before {
        color: ${props => props.theme.color.secondary};
      }
    }
  }

  ${Title} {
    margin-bottom: ${props => props.theme.layout.gutter / 2}px;
  }

  ${media.tablet`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    
    width: 50vw;
  `};

  ${media.desktop`
    width: 62vw;
    align-items: flex-start;

    ${Title} {
      margin: 0 ${props => props.theme.layout.gutter}px 0 0;
    }
  `};
`;

export const DIV = styled.div`
  font-family: ${props => props.theme.font.body2.fontFamily};
  font-size: ${props => props.theme.font.body2.fontSize};
  line-height: ${props => props.theme.font.body2.lineHeight};
  color: ${props => props.theme.color.brand.white};
  text-align: left;
  max-width: 200px;

  ${media.tablet`
    max-width: unset;
  `};
`;

export const BadgeWrapper = styled.div`
  position: absolute;
  top: -36px;
  right: 0px;

  ${media.tablet`
    top: -32px;
    right: 50px;
  `};
`;

export const CollectionWrapper = styled.a`
  display: block;

  color: ${props => props.theme.color.white};
  text-decoration: none;

  margin: ${props => props.theme.layout.gutter * 0.75}px 0
    ${props => props.theme.layout.gutter * 1.5}px;

  .collection {
    justify-content: center;
  }

  ${media.tablet`
    margin: 0 0 ${props => props.theme.layout.gutter * 2.5}px;
  `};
`;

export const MapWrapper = styled.div`
  height: 425px;

  ${media.tablet`
    position: relative;
    margin-left: 5%;
    width: 90%; height: 100%;
  `};
`;

export const Image = styled.img`
  position: relative;
  left: 50%;

  width: 250%;
  height: auto;

  transform: translate3d(-50%, 0, 0);

  ${media.tablet`
    position: absolute;
    top: 0;

    width: 120%;
    height: 100%;

    object-fit: contain;
    font-family: 'object-fit: contain;';
  `};

  ${media.desktop`
    left: 0;
    width: 100%;
    transform: none;
  `};
`;

export const TitleWrapper = styled.div`
  padding: ${props => props.theme.layout.gutter * 1.5}px 0 0;

  ${media.tablet`
    padding: ${props => props.theme.layout.gutter * 3.25}px ${props =>
    props.theme.layout.gutter}px 0;
  `};

  ${media.desktop`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    padding: ${props => props.theme.layout.gutter * 3.25}px 5vw 0;
  `};
`;
